import gql from 'graphql-tag';

const GET_GEO_IP_LOCATION = gql`
  query GetGeoIpLocation {
    geoIPLocation {
      continentCode
      countryCode: countryIsoCode
      sub1Code: subdivision1IsoCode
      cityName
      timeZone
      zipCode: postalCode
    }
  }
`;

export default GET_GEO_IP_LOCATION;
